
import {
    Form, Row, Col, Input, AspectRatio, Button,
    ProTableOt, useProTableOt, setParamsFilter,
    Typography,ImageFileId
} from '../../ui/ot'
import { useEffect, useState, useRef } from "react"
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useBib } from '../../koha/controllers/bib_controller';
import { useTranslation } from "react-i18next";
import { Badge } from "../../ui/badge"

const ItemTable = ({
    keyPrefix = 'library.online_public_catalog_query_construction.collection_search',
    bibValue = null,
    extraActionRender = () => { }
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const biblionumber = searchParams.get("biblionumber")
    const actionRef = useRef(null);
    const [tableSearchParams, setTableSearchParams] = useState({
        biblionumber: bibValue?.bib_biblionumber
    });
    const columns = [
        {
            title: '#',
            dataIndex: 'key',
            key: 'key',
        },
        {
            title: t(`Images`),
            dataIndex: 'file_id',
            key: 'file_id',
            sorter: false,
            width: 50,
            render: (text, record, index) => {
                if (!!text) {
                    return (<ImageFileId
                        file_id={text}
                        width={"50px"}
                    />)
                }
                else {
                    return ("-")
                }

            }
        },
        {
            title: t(`Item_type`),
            dataIndex: 'item_itype_description',
            key: 'item_itype_description',
        },
        {
            title: t(`Current library`),
            dataIndex: 'item_branchname_holding',
            key: 'item_branchname_holding',
        },
        {
            title: t(`Home library`),
            dataIndex: 'item_branchname_home',
            key: 'item_branchname_home',
        },
        {
            title: t(`item_barcode`),
            dataIndex: 'item_barcode',
            key: 'item_barcode',
        },
        {
            title: t(`call_number`),
            dataIndex: 'item_itemcallnumber',
            key: 'item_itemcallnumber',
        },
        {
            title: t(`item_serial_issue_number`),
            dataIndex: 'item_serial_issue_number',
            key: 'item_serial_issue_number',
        },
        
        {
            title: t(`Status`),
            dataIndex: 'issue_cancheckout',
            key: 'issue_cancheckout',
            render: (text, record, index) => {
                let tags = ['item_damaged_authorised_values', 'item_notforloan_authorised_values', 'item_restricted_authorised_values', 'item_withdrawn_authorised_values']
                let statusCount = 0
                tags.forEach((ele) => {
                    if (!!record?.[ele]) {
                        statusCount++
                    }
                })
               
                if (!!record?.issue_cancheckout  ) {
                    return <>
                        {t(`CanCheckout`)}
                    </>
                } else {
                    if (statusCount > 0) {
                        return (<>
                            不可借出
                            <p>
                                {record?.item_damaged_authorised_values && <Badge>
                                    {record?.item_damaged_authorised_values}
                                </Badge>}
                            </p>
                            <p>
                                {record?.item_notforloan_authorised_values && <Badge>
                                    {record?.item_notforloan_authorised_values}
                                </Badge>}
                            </p>
                            <p>
                                {record?.item_restricted_authorised_values && <Badge>
                                    {record?.item_restricted_authorised_values}
                                </Badge>}
                            </p>
                            <p>
                                {record?.item_withdrawn_authorised_values && <Badge>
                                    {record?.item_withdrawn_authorised_values}
                                </Badge>}
                            </p>

                        </>)
                    }
                    else {
                        return t(`CantCheckout`)
                    }
                    
                }
            }
        },
        {
            title: t(`Date last borrowed`),
            dataIndex: 'item_datelastborrowed',
            key: 'item_datelastborrowed',
        },
        {
            title: t(`Copy number`),
            dataIndex: 'item_copynumber',
            key: 'item_copynumber',
        },
        {
            title: t('action'),
            dataIndex: 'action',
            key: 'action',
            render: (_, record) => {
                return (<>
                    {extraActionRender(record)}
                </>)
            }
        },
    ];
    const bibItemController = useCRUDController({
        apiRoute: "/koha/item",
    })

    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });

    useEffect(() => {
        checkAll();

    }, [])
    return (<Row >
        <Col span={24}  >
            <ProTableOt
                searchParams={tableSearchParams}
                showSearch={false}
                reloadButton={false}
                manageColumnsButton={false}
                rowKey={"item_itemnumber"}
                actionRef={actionRef}
                columns={columns}
                check={check}
                setCheck={setCheck}
                request={async (params = {}, sort, filter) => {
                    // setAxiosMethod("get")
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params.pageSize,
                        cur_page: params.current,
                        // custom_filter_value: params.keyword ?? "",
                        // custom_filter_key: custom_filter_key,
                        ...tableSearchParams
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    return bibItemController.getData({
                        ...newParams,
                    });
                }}
                rowSelection={false}
                manage_columns={true}
            />
        </Col>
    </Row>)
}
export default ItemTable